import { Update, Publisher, PagedUpdatesResponse, PagedContractsResponse } from 'cmp-client-api';
import { Indicators } from 'swo-ciam-common-react';

import {
  PageablePublisherContracts,
  PageablePublisherUpdates,
  PublisherUpdate,
  PublisherUpdateRegionEnumType,
  PublisherUpdateStatusEnumType,
  PublisherUpdateTypeEnumType,
} from '@src/domain/pages/publisher-updates/table/types';
import { MapperInterface } from './types/mapper.interface';

const defaultPublisher: Publisher = {
  name: Indicators.Dash,
  id: '',
  iconSrc: '',
  iconName: '',
  description: '',
  type: '',
};

const transformFromApiModel = (items: Update[] = []): PublisherUpdate[] =>
  items.map((item) => ({
    id: item.id,
    type: item.type,
    kind: item.kind as PublisherUpdateTypeEnumType,
    name: item.name,
    publisher: item.publisher || defaultPublisher,
    status: item.status as PublisherUpdateStatusEnumType,
    scopes: (item.scopes || [null]) as PublisherUpdateRegionEnumType[],
    callToAction: item.callToAction,
    customerImpact: item.customerImpact,
    description: item.description,
    impactedContract: item.impactedContract,
    impactedProduct: item.impactedProduct,
    impactSummary: item.impactSummary,
    impactSummaryHtml: item.impactSummaryHtml,
    impactLevel: item.impactLevel,
    relevantCustomerRoles: item.relevantCustomerRoles,
    linkToPublisherAnnouncement: item.linkToPublisherAnnouncement,
    subject: item.subject,
    relevanceStartDate: item.relevanceStartDate ? new Date(item.relevanceStartDate) : undefined,
    relevanceEndDate: item.relevanceEndDate ? new Date(item.relevanceEndDate) : undefined,
    modifyDate: item.modifyDate ? new Date(item.modifyDate) : undefined,
    createDate: item.createDate ? new Date(item.createDate) : undefined,
    callToActionHtml: item.callToActionHtml,
    clientImpactHtml: item.clientImpactHtml,
    descriptionHtml: item.descriptionHtml,
    attachments: Array.isArray(item.attachments) ? item.attachments : item.attachments?.data || [],
  }));

export const PublisherUpdatesMapper: MapperInterface<PublisherUpdate[], Update[]> = {
  transformFromApiModel,
};

const transformFromPageApiModel = (
  apiResponse: PagedUpdatesResponse
): PageablePublisherUpdates => ({
  items: transformFromApiModel(apiResponse.items),
  pageInfo: apiResponse.pageInfo,
});

export const PagedPublisherUpdatesMapper: MapperInterface<
  PageablePublisherUpdates,
  PagedUpdatesResponse
> = {
  transformFromApiModel: transformFromPageApiModel,
};

const transformFromPublisherContractsPageApiModel = (
  apiResponse: PagedContractsResponse
): PageablePublisherContracts => ({
  items: apiResponse.data,
  pageInfo: apiResponse.pagination,
});

export const PagedPublisherContractsMapper: MapperInterface<
  PageablePublisherContracts,
  PagedContractsResponse
> = {
  transformFromApiModel: transformFromPublisherContractsPageApiModel,
};
